{
  "name": "frontend",
  "version": "0.51.3",
  "description": "Fuse - Angular Admin Template and Starter Project",
  "author": "https://themeforest.net/user/srcn",
  "license": "https://themeforest.net/licenses/standard",
  "private": true,
  "scripts": {
    "prestart": "rimraf .angular",
    "prestart:dev": "rimraf .angular",
    "prestart:test": "rimraf .angular",
    "prebuild": "rimraf .angular",
    "prebuild:dev": "rimraf .angular",
    "prebuild:test": "rimraf .angular",
    "prebuild:prod": "rimraf .angular",
    "ng": "ng",
    "start": "ng serve --configuration local",
    "start:dev": "ng serve --configuration development",
    "start:test": "ng serve --configuration test",
    "build": "ng build --configuration local",
    "build:dev": "ng build --configuration development",
    "build:test": "ng build --configuration test",
    "build:prod": "ng build --configuration production",
    "test": "ng test",
    "docker:build": "docker build -t crlabdev1.azurecr.io/beta.testlab360.com.au:$(git rev-parse --verify HEAD) -t crlabdev1.azurecr.io/beta.testlab360.com.au:latest -f Dockerfile .",
    "docker:run": "docker run -it --net='host' crlabdev1.azurecr.io/beta.testlab360.com.au:$(git rev-parse --verify HEAD)",
    "docker:push": "docker push crlabdev1.azurecr.io/beta.testlab360.com.au:$(git rev-parse --verify HEAD)",
    "compodoc": "npx compodoc -p tsconfig.doc.json",
    "compodoc:build": "compodoc -p tsconfig.doc.json",
    "compodoc:serve": "compodoc -s",
    "docs": "compodoc -p tsconfig.doc.json -s",
    "generate-api": "nswag run /runtime:Net100"
  },
  "dependencies": {
    "@angular/animations": "20.3.34",
    "@angular/cdk": "20.2.14",
    "@angular/common": "20.3.34",
    "@angular/compiler": "20.3.34",
    "@angular/core": "20.3.34",
    "@angular/forms": "20.3.34",
    "@angular/material": "20.2.14",
    "@angular/material-luxon-adapter": "20.2.14",
    "@angular/platform-browser": "20.3.34",
    "@angular/platform-browser-dynamic": "20.3.34",
    "@angular/router": "20.3.34",
    "@ctrl/ngx-csv": "6.0.0",
    "@flatfile/angular-sdk": "1.5.3",
    "@flatfile/listener": "1.1.2",
    "@flatfile/plugin-record-hook": "2.0.3",
    "@fortawesome/fontawesome-free": "7.3.1",
    "@fullcalendar/angular": "7.1.2",
    "@fullcalendar/core": "7.1.2",
    "@fullcalendar/daygrid": "6.1.21",
    "@handsontable/angular": "16.2.0",
    "@microsoft/signalr": "10.0.11",
    "@ng-select/ng-select": "24.2.1",
    "@ngneat/transloco": "6.0.4",
    "@opentelemetry/api": "1.9.1",
    "@opentelemetry/api-logs": "0.223.0",
    "@opentelemetry/context-zone-peer-dep": "2.12.0",
    "@opentelemetry/exporter-logs-otlp-http": "0.223.0",
    "@opentelemetry/exporter-metrics-otlp-http": "0.223.0",
    "@opentelemetry/exporter-trace-otlp-http": "0.223.0",
    "@opentelemetry/instrumentation": "0.223.0",
    "@opentelemetry/instrumentation-document-load": "0.68.0",
    "@opentelemetry/instrumentation-fetch": "0.223.0",
    "@opentelemetry/opentelemetry-browser-detector": "0.223.0",
    "@opentelemetry/resources": "2.12.0",
    "@opentelemetry/sdk-logs": "0.223.0",
    "@opentelemetry/sdk-metrics": "2.12.0",
    "@opentelemetry/sdk-trace-web": "2.12.0",
    "@opentelemetry/semantic-conventions": "1.43.0",
    "@swimlane/ngx-datatable": "22.0.0",
    "@syncfusion/ej2-angular-calendars": "33.1.44",
    "@syncfusion/ej2-angular-charts": "33.1.47",
    "@syncfusion/ej2-angular-dropdowns": "33.1.47",
    "@syncfusion/ej2-angular-grids": "33.1.47",
    "@syncfusion/ej2-angular-inputs": "33.1.47",
    "@syncfusion/ej2-angular-schedule": "33.1.47",
    "@zxing/browser": "0.2.1",
    "@zxing/library": "0.23.0",
    "@zxing/ngx-scanner": "22.0.1",
    "ag-grid-angular": "35.2.1",
    "ag-grid-community": "35.2.1",
    "ag-grid-enterprise": "35.2.1",
    "angular-signature-pad-v2": "10.0.0",
    "angularx-qrcode": "22.0.1",
    "bootstrap": "5.3.8",
    "cesium": "1.143.0",
    "crisp-sdk-web": "1.2.1",
    "csstype": "3.2.3",
    "decimal.js": "10.6.0",
    "handsontable": "14.5.0",
    "highlight.js": "11.12.0",
    "immutable": "5.1.9",
    "lodash-es": "4.18.1",
    "luxon": "3.7.2",
    "ng2-pdfjs-viewer": "26.4.4",
    "ngx-bootstrap": "21.0.1",
    "ngx-color": "10.1.0",
    "ngx-color-picker": "17.0.0",
    "ngx-print": "21.2.0",
    "ngx-quill": "30.0.1",
    "ngx-toggle-button": "14.0.0-beta.2",
    "oidc-client-ts": "3.5.0",
    "parchment": "3.0.0",
    "perfect-scrollbar": "1.5.6",
    "powerbi-client-angular": "6.0.3",
    "quill": "2.0.3",
    "quill-delta": "5.1.0",
    "rxjs": "7.8.2",
    "signature_pad": "5.1.4",
    "tslib": "2.8.1",
    "web-vitals": "6.2.3",
    "xlsx": "0.18.5",
    "zone.js": "0.16.3"
  },
  "devDependencies": {
    "@angular/build": "20.3.41",
    "@angular/cli": "20.3.41",
    "@angular/compiler-cli": "20.3.34",
    "@compodoc/compodoc": "2.0.0",
    "@tailwindcss/typography": "0.5.20",
    "@types/cesium": "1.70.0",
    "@types/chroma-js": "3.1.2",
    "@types/file-saver": "2.0.7",
    "@types/highlight.js": "10.1.0",
    "@types/jasmine": "7.0.0",
    "@types/lodash": "4.17.26",
    "@types/lodash-es": "4.17.12",
    "@types/luxon": "3.7.6",
    "@types/sortablejs": "1.15.9",
    "autoprefixer": "10.6.1",
    "chroma-js": "3.2.0",
    "jasmine-core": "7.0.2",
    "karma": "6.4.4",
    "karma-chrome-launcher": "3.2.0",
    "karma-coverage": "2.2.1",
    "karma-jasmine": "5.1.0",
    "karma-jasmine-html-reporter": "2.3.0",
    "lodash": "4.18.1",
    "postcss": "8.5.30",
    "prettier": "3.9.10",
    "rimraf": "6.1.3",
    "tailwindcss": "3.4.1",
    "typescript": "5.8.3",
    "nswag": "14.7.1"
  }
}
